import React from "react";
import { ModuleItem } from "Components/overview";
import { Grid } from "@mui/material";
import { surface } from "../../../../theme/muiTheme";

const MeasurementsList = ({ combineMeasureAndCommands, solutionType, showDeviceTags, showLinearGauges, measurementTags, dataIsRecent, config, isCompact }) => (
  <Grid container>
    {combineMeasureAndCommands &&
      combineMeasureAndCommands.map((item, index) => {
        return (
          <Grid
            size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: isCompact ? 6 : 4 }}
            sx={(theme) => ({
              p: 0.5,
              borderRight: {
                xs: "none",
                md: index % 2 === 0 ? `2px solid ${theme.palette.grey[600]}` : "none",
                xl: isCompact ? (index % 2 === 0 ? `2px solid ${theme.palette.grey[600]}` : "none") : (index % 3 !== 2 ? `2px solid ${theme.palette.grey[600]}` : "none"),
              },
              borderBottom: `1px solid ${surface.hairline}`,
            })}
            key={item.displayName + index}
          >
            <ModuleItem
              displayName={item.displayName}
              valueName={item.valueName}
              value={item.value}
              unit={item.unit}
              valueTimestamp={item.valueTimestamp}
              solutionType={solutionType}
              category={item.category}
              isAlarmActive={item.isActive}
              showDeviceTags={showDeviceTags}
              tag={measurementTags[index] ? measurementTags[index].tag : ""}
              showLinearGauges={showLinearGauges}
              dataIsRecent={dataIsRecent}
              hwId={item.hwId}
              config={config}
            />
          </Grid>
        );
      })}
  </Grid >
);



export default MeasurementsList;
